export default __webpack_public_path__ + "static/media/microphone.6ded7abe.svg";